import { useState } from 'react';
import { MyProfileAvatar } from '@/components/my-profile-avatar';
import { QuickActionsNav } from '@/components/quick-actions-nav';
import { TradingDatePicker } from '@/features/trading/components/trading-date-picker';
import { AutoTraderStatusBadge } from '@/features/trading/components/auto-trader-status-badge';
import OverviewCards from '@/features/trading/components/overview-cards';
import BatteryAllocationGauge from '@/features/trading/components/battery-allocation-gauge';
import ArbitrageCalculator from '@/features/trading/components/arbitrage-calculator';
import CompetingActivities from '@/features/trading/components/competing-activities';
import PlantsOverview from '@/features/trading/components/plants-overview';
import AutoTraderStatus from '@/features/trading/components/auto-trader-status';
import ManualTrade from '@/features/trading/components/manual-trade';
import LoadForecastComparison from '@/features/trading/components/load-forecast-comparison';
import PriceDeltaHeatmap from '@/features/trading/components/price-delta-heatmap';
import EnergyPricesAndBatteryMetrics from '@/features/trading/components/energy-prices-and-battery-metrics';
import TradeQueue from '@/features/trading/components/trade-queue';
import { useGetOverviewTradingQuery } from '@/features/trading/hooks/queries/use-get-overview-trading.ts';

const TradingPage = () => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());

  useGetOverviewTradingQuery({ date: selectedDate });

  return (
    <div className="w-full gap-2 px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Energy Trading</h1>
          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div className="flex min-h-screen flex-col gap-6 bg-zinc-50 text-zinc-900">
          <div className="flex items-center justify-between text-base">
            <AutoTraderStatusBadge />
            <TradingDatePicker initialDate={selectedDate} onUpdate={setSelectedDate} />
          </div>
          <OverviewCards />
          <div className="grid grid-cols-[380px_1fr] gap-5">
            <div className="flex flex-col gap-5">
              <BatteryAllocationGauge />
              <ArbitrageCalculator />
              <CompetingActivities />
              <PlantsOverview />
              <AutoTraderStatus />
              <ManualTrade />
            </div>

            <div className="flex flex-col gap-5">
              <EnergyPricesAndBatteryMetrics selectedDate={selectedDate} />
              <LoadForecastComparison selectedDate={selectedDate} />
              <PriceDeltaHeatmap selectedDate={selectedDate} />
              <TradeQueue />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingPage;
